"use client";

// A clean, text-only rendering of the entire site content.
// No animations, no canvas, no interactive forms — just readable content.
import { c as _c } from "react/compiler-runtime";
const stack = [{
  category: "Frontend & Design",
  tech: ["Next.js", "React", "Angular", "TypeScript", "Tailwind CSS"]
}, {
  category: "Backend & Database",
  tech: ["NestJS", "Express.js", "Python", "Flask", "Postgres", "MongoDB"]
}, {
  category: "Architecture & DevOps",
  tech: ["Docker", "Kubernetes", "Jenkins", "Linux OS", "Nexus Repo"]
}, {
  category: "API & Testing",
  tech: ["Postman", "Jest", "Selenium", "BeautifulSoup", "REST APIs", "GraphQL"]
}, {
  category: "Agile & Collab",
  tech: ["Git", "Jira", "Trello", "Notion", "Slack"]
}, {
  category: "AI & Engineering",
  tech: ["RAG Pipelines", "LLM Fine-Tuning", "Prompt Engineering"]
}];
interface Project {
  id: string;
  title: string;
  subtitle?: string;
  description: string;
  tech: string[];
  github?: string;
  demo?: string;
}
interface ReaderModeViewProps {
  dict: Record<string, Record<string, unknown>>;
  locale: string;
  onExit: () => void;
}
export default function ReaderModeView(t0) {
  const $ = _c(109);
  const {
    dict,
    locale,
    onExit
  } = t0;
  let t1;
  if ($[0] !== dict.hero) {
    t1 = dict.hero as Record<string, string> || {};
    $[0] = dict.hero;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hero = t1;
  let t2;
  if ($[2] !== dict.about) {
    t2 = dict.about as Record<string, string> || {};
    $[2] = dict.about;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const about = t2;
  let t3;
  if ($[4] !== dict.projects) {
    t3 = dict.projects as Record<string, unknown> || {};
    $[4] = dict.projects;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const projects = t3;
  let t4;
  if ($[6] !== projects.list) {
    t4 = projects.list as Project[] || [];
    $[6] = projects.list;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const projectList = t4;
  let t5;
  if ($[8] !== dict.cta) {
    t5 = dict.cta as Record<string, string> || {};
    $[8] = dict.cta;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const cta = t5;
  const isRtl = locale === "ar";
  const t6 = isRtl ? "rtl" : "ltr";
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      overflow: "auto",
      backgroundColor: "#fafaf9",
      color: "#111",
      fontFamily: "inherit"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = isRtl ? "left" : "right";
  const t9 = isRtl ? "0" : "2rem";
  const t10 = isRtl ? "2rem" : "0";
  let t11;
  if ($[11] !== t10 || $[12] !== t8 || $[13] !== t9) {
    t11 = {
      position: "sticky",
      top: "1.5rem",
      float: t8,
      marginRight: t9,
      marginLeft: t10,
      marginBottom: "-3rem",
      zIndex: 10,
      padding: "0.4rem 1.1rem",
      border: "1.5px solid #111",
      borderRadius: "4px",
      background: "#fff",
      color: "#111",
      fontWeight: 700,
      fontSize: "0.85rem",
      cursor: "pointer",
      letterSpacing: "0.04em",
      textTransform: "uppercase"
    };
    $[11] = t10;
    $[12] = t8;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== onExit || $[16] !== t11) {
    t12 = <button onClick={onExit} style={t11} aria-label="Exit text-only mode">✕ Exit</button>;
    $[15] = onExit;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  let t14;
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      maxWidth: "680px",
      margin: "0 auto",
      padding: "4rem 1.5rem 6rem"
    };
    t14 = {
      marginBottom: "3rem",
      borderBottom: "2px solid #111",
      paddingBottom: "2rem"
    };
    t15 = {
      fontSize: "0.8rem",
      fontWeight: 700,
      letterSpacing: "0.15em",
      textTransform: "uppercase",
      color: "#666",
      marginBottom: "0.5rem"
    };
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
  } else {
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
  }
  const t16 = hero.availability || "Available: Full-Time / Freelance";
  let t17;
  if ($[21] !== t16) {
    t17 = <p style={t15}>{t16}</p>;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  let t19;
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <h1 style={{
      fontSize: "3rem",
      fontWeight: 900,
      lineHeight: 1.05,
      letterSpacing: "-0.03em",
      margin: "0 0 0.5rem"
    }}>Samy Barsoum</h1>;
    t19 = <p style={{
      fontSize: "1.1rem",
      color: "#444",
      lineHeight: 1.6,
      marginTop: "1rem"
    }}>Full-Stack Developer · Based in Egypt · Building end-to-end digital products.</p>;
    t20 = {
      marginTop: "1rem",
      fontSize: "0.95rem",
      color: "#555"
    };
    $[23] = t18;
    $[24] = t19;
    $[25] = t20;
  } else {
    t18 = $[23];
    t19 = $[24];
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <a href="mailto:samy.barsoum@example.com" style={{
      color: "inherit",
      textDecoration: "underline"
    }}>samyb.samir [at] gmail [dot] com</a>;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <a href="https://github.com/samybit" target="_blank" rel="noopener noreferrer" style={{
      color: "inherit",
      textDecoration: "underline"
    }}>github.com/samybit</a>;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  let t23;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p style={t20}>{t21}{" \xB7 "}{t22}{" \xB7 "}<a href="https://www.linkedin.com/in/samy-barsoum" target="_blank" rel="noopener noreferrer" style={{
        color: "inherit",
        textDecoration: "underline"
      }}>linkedin.com/in/samy-barsoum</a></p>;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== t17) {
    t24 = <header style={t14}>{t17}{t18}{t19}{t23}</header>;
    $[29] = t17;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  let t26;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      marginBottom: "3rem"
    };
    t26 = <h2 style={headingStyle}>About</h2>;
    $[31] = t25;
    $[32] = t26;
  } else {
    t25 = $[31];
    t26 = $[32];
  }
  const t27 = about.bioP1 || "My journey began with Python automation and scripting, building tools to scrape data and automate tasks. I then expanded into full-stack development, mastering the MERN stack to engineer dynamic applications.";
  let t28;
  if ($[33] !== t27) {
    t28 = <p style={bodyStyle}>{t27}</p>;
    $[33] = t27;
    $[34] = t28;
  } else {
    t28 = $[34];
  }
  let t29;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      ...bodyStyle,
      marginTop: "0.75rem"
    };
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  const t30 = about.bioP2 || "Today, I focus on building complete, containerized applications using Docker, ensuring that what runs on my machine runs everywhere.";
  let t31;
  if ($[36] !== t30) {
    t31 = <p style={t29}>{t30}</p>;
    $[36] = t30;
    $[37] = t31;
  } else {
    t31 = $[37];
  }
  let t32;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      ...bodyStyle,
      marginTop: "0.75rem"
    };
    $[38] = t32;
  } else {
    t32 = $[38];
  }
  const t33 = about.bioP3 || "When I'm not coding, you can find me exploring retro tech, playing classic games, or experimenting with 3D web graphics.";
  let t34;
  if ($[39] !== t33) {
    t34 = <p style={t32}>{t33}</p>;
    $[39] = t33;
    $[40] = t34;
  } else {
    t34 = $[40];
  }
  let t35;
  if ($[41] !== t28 || $[42] !== t31 || $[43] !== t34) {
    t35 = <section style={t25}>{t26}{t28}{t31}{t34}</section>;
    $[41] = t28;
    $[42] = t31;
    $[43] = t34;
    $[44] = t35;
  } else {
    t35 = $[44];
  }
  let t36;
  let t37;
  let t38;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      marginBottom: "3rem"
    };
    t37 = <h2 style={headingStyle}>Education</h2>;
    t38 = {
      ...bodyStyle,
      fontWeight: 700
    };
    $[45] = t36;
    $[46] = t37;
    $[47] = t38;
  } else {
    t36 = $[45];
    t37 = $[46];
    t38 = $[47];
  }
  const t39 = about.eduSchool || "Ain Shams University";
  let t40;
  if ($[48] !== t39) {
    t40 = <p style={t38}>{t39}</p>;
    $[48] = t39;
    $[49] = t40;
  } else {
    t40 = $[49];
  }
  const t41 = about.eduDegree || "Bachelor of Commerce (B.B.A.) // 2019 - 2023";
  let t42;
  if ($[50] !== t41) {
    t42 = <p style={bodyStyle}>{t41}</p>;
    $[50] = t41;
    $[51] = t42;
  } else {
    t42 = $[51];
  }
  let t43;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      ...bodyStyle,
      color: "#555",
      marginTop: "0.4rem"
    };
    $[52] = t43;
  } else {
    t43 = $[52];
  }
  const t44 = about.eduDesc || "Specialized in accounting and project management.";
  let t45;
  if ($[53] !== t44) {
    t45 = <p style={t43}>{t44}</p>;
    $[53] = t44;
    $[54] = t45;
  } else {
    t45 = $[54];
  }
  let t46;
  if ($[55] !== t40 || $[56] !== t42 || $[57] !== t45) {
    t46 = <section style={t36}>{t37}{t40}{t42}{t45}</section>;
    $[55] = t40;
    $[56] = t42;
    $[57] = t45;
    $[58] = t46;
  } else {
    t46 = $[58];
  }
  let t47;
  let t48;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      marginBottom: "3rem"
    };
    t48 = <h2 style={headingStyle}>Certifications</h2>;
    $[59] = t47;
    $[60] = t48;
  } else {
    t47 = $[59];
    t48 = $[60];
  }
  const t49 = about.mernStack || "Web Dev & Gen AI";
  let t50;
  if ($[61] !== t49) {
    t50 = <li>{t49}</li>;
    $[61] = t49;
    $[62] = t50;
  } else {
    t50 = $[62];
  }
  const t51 = about.cs50 || "CS50x (Harvard)";
  let t52;
  if ($[63] !== t51) {
    t52 = <li>{t51}</li>;
    $[63] = t51;
    $[64] = t52;
  } else {
    t52 = $[64];
  }
  const t53 = about.dataAnalysis || "Data Analysis";
  let t54;
  if ($[65] !== t53) {
    t54 = <li>{t53}</li>;
    $[65] = t53;
    $[66] = t54;
  } else {
    t54 = $[66];
  }
  let t55;
  if ($[67] !== t50 || $[68] !== t52 || $[69] !== t54) {
    t55 = <section style={t47}>{t48}<ul style={listStyle}>{t50}{t52}{t54}</ul></section>;
    $[67] = t50;
    $[68] = t52;
    $[69] = t54;
    $[70] = t55;
  } else {
    t55 = $[70];
  }
  let t56;
  let t57;
  let t58;
  let t59;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <section style={{
      marginBottom: "3rem"
    }}><h2 style={headingStyle}>Technical Skills</h2><div style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1.25rem",
        marginTop: "1rem"
      }}>{stack.map(_temp)}</div></section>;
    t57 = {
      marginBottom: "3rem"
    };
    t58 = <h2 style={headingStyle}>Selected Projects</h2>;
    t59 = {
      display: "flex",
      flexDirection: "column",
      gap: "1.75rem",
      marginTop: "1rem"
    };
    $[71] = t56;
    $[72] = t57;
    $[73] = t58;
    $[74] = t59;
  } else {
    t56 = $[71];
    t57 = $[72];
    t58 = $[73];
    t59 = $[74];
  }
  let t60;
  if ($[75] !== projectList) {
    t60 = projectList.map(_temp2);
    $[75] = projectList;
    $[76] = t60;
  } else {
    t60 = $[76];
  }
  let t61;
  if ($[77] !== t60) {
    t61 = <section style={t57}>{t58}<div style={t59}>{t60}</div></section>;
    $[77] = t60;
    $[78] = t61;
  } else {
    t61 = $[78];
  }
  let t62;
  let t63;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = {
      borderTop: "2px solid #111",
      paddingTop: "2rem"
    };
    t63 = <h2 style={headingStyle}>Get In Touch</h2>;
    $[79] = t62;
    $[80] = t63;
  } else {
    t62 = $[79];
    t63 = $[80];
  }
  const t64 = cta.description || "Currently open for freelance projects and full-time roles.";
  let t65;
  if ($[81] !== t64) {
    t65 = <p style={bodyStyle}>{t64}</p>;
    $[81] = t64;
    $[82] = t65;
  } else {
    t65 = $[82];
  }
  let t66;
  let t67;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = {
      marginTop: "0.75rem",
      fontSize: "1rem"
    };
    t67 = <strong>Email:</strong>;
    $[83] = t66;
    $[84] = t67;
  } else {
    t66 = $[83];
    t67 = $[84];
  }
  let t68;
  let t69;
  let t70;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <p style={t66}>{t67}{" "}<a href="mailto:samyb.samir@gmail.com" style={{
        color: "#111",
        textDecoration: "underline"
      }}>samyb.samir [at] gmail [dot] com</a></p>;
    t69 = {
      marginTop: "0.35rem",
      fontSize: "1rem"
    };
    t70 = <strong>LinkedIn:</strong>;
    $[85] = t68;
    $[86] = t69;
    $[87] = t70;
  } else {
    t68 = $[85];
    t69 = $[86];
    t70 = $[87];
  }
  let t71;
  let t72;
  let t73;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = <p style={t69}>{t70}{" "}<a href="https://www.linkedin.com/in/samy-barsoum" target="_blank" rel="noopener noreferrer" style={{
        color: "#111",
        textDecoration: "underline"
      }}>linkedin.com/in/samy-barsoum</a></p>;
    t72 = {
      marginTop: "0.35rem",
      fontSize: "1rem"
    };
    t73 = <strong>GitHub:</strong>;
    $[88] = t71;
    $[89] = t72;
    $[90] = t73;
  } else {
    t71 = $[88];
    t72 = $[89];
    t73 = $[90];
  }
  let t74;
  let t75;
  let t76;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <p style={t72}>{t73}{" "}<a href="https://github.com/samybit" target="_blank" rel="noopener noreferrer" style={{
        color: "#111",
        textDecoration: "underline"
      }}>github.com/samybit</a></p>;
    t75 = {
      marginTop: "0.35rem",
      fontSize: "1rem"
    };
    t76 = <strong>Behance:</strong>;
    $[91] = t74;
    $[92] = t75;
    $[93] = t76;
  } else {
    t74 = $[91];
    t75 = $[92];
    t76 = $[93];
  }
  let t77;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <p style={t75}>{t76}{" "}<a href="https://www.behance.net/samy-barsoum" target="_blank" rel="noopener noreferrer" style={{
        color: "#111",
        textDecoration: "underline"
      }}>behance.net/samy-barsoum</a></p>;
    $[94] = t77;
  } else {
    t77 = $[94];
  }
  let t78;
  if ($[95] !== t65) {
    t78 = <section style={t62}>{t63}{t65}{t68}{t71}{t74}{t77}</section>;
    $[95] = t65;
    $[96] = t78;
  } else {
    t78 = $[96];
  }
  let t79;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <p style={{
      marginTop: "3rem",
      fontSize: "0.75rem",
      color: "#aaa",
      textAlign: "center"
    }}>samyb.vercel.app · Text-Only Mode</p>;
    $[97] = t79;
  } else {
    t79 = $[97];
  }
  let t80;
  if ($[98] !== t24 || $[99] !== t35 || $[100] !== t46 || $[101] !== t55 || $[102] !== t61 || $[103] !== t78) {
    t80 = <div style={t13}>{t24}{t35}{t46}{t55}{t56}{t61}{t78}{t79}</div>;
    $[98] = t24;
    $[99] = t35;
    $[100] = t46;
    $[101] = t55;
    $[102] = t61;
    $[103] = t78;
    $[104] = t80;
  } else {
    t80 = $[104];
  }
  let t81;
  if ($[105] !== t12 || $[106] !== t6 || $[107] !== t80) {
    t81 = <div dir={t6} style={t7}>{t12}{t80}</div>;
    $[105] = t12;
    $[106] = t6;
    $[107] = t80;
    $[108] = t81;
  } else {
    t81 = $[108];
  }
  return t81;
}
function _temp2(project) {
  return <div key={project.id} style={{
    borderLeft: "3px solid #111",
    paddingLeft: "1rem"
  }}><p style={{
      fontWeight: 800,
      fontSize: "1rem",
      marginBottom: "0.25rem"
    }}>{project.title}{project.github && <a href={project.github} target="_blank" rel="noopener noreferrer" style={{
        marginLeft: "0.75rem",
        fontSize: "0.75rem",
        color: "#555",
        fontWeight: 600,
        textDecoration: "underline"
      }}>↗ GitHub</a>}{project.demo && project.demo !== "#" && <a href={project.demo} target="_blank" rel="noopener noreferrer" style={{
        marginLeft: "0.5rem",
        fontSize: "0.75rem",
        color: "#555",
        fontWeight: 600,
        textDecoration: "underline"
      }}>↗ Demo</a>}</p>{project.subtitle && <p style={{
      fontSize: "0.8rem",
      color: "#666",
      fontWeight: 600,
      marginBottom: "0.25rem"
    }}>{project.subtitle}</p>}<p style={{
      fontSize: "0.9rem",
      color: "#444",
      lineHeight: 1.6,
      marginBottom: "0.35rem",
      whiteSpace: "pre-line"
    }}>{project.description}</p><p style={{
      fontSize: "0.75rem",
      color: "#888",
      letterSpacing: "0.05em"
    }}>{project.tech.join(" \xB7 ")}</p></div>;
}
function _temp(cat) {
  return <div key={cat.category}><p style={{
      fontSize: "0.75rem",
      fontWeight: 800,
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      color: "#666",
      marginBottom: "0.35rem"
    }}>{cat.category}</p><p style={{
      fontSize: "0.9rem",
      color: "#333",
      lineHeight: 1.6
    }}>{cat.tech.join(", ")}</p></div>;
}
const headingStyle: React.CSSProperties = {
  fontSize: "0.7rem",
  fontWeight: 900,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#111",
  borderBottom: "1px solid #ddd",
  paddingBottom: "0.4rem",
  marginBottom: "1rem"
};
const bodyStyle: React.CSSProperties = {
  fontSize: "0.975rem",
  lineHeight: 1.75,
  color: "#333"
};
const listStyle: React.CSSProperties = {
  paddingLeft: "1.25rem",
  fontSize: "0.95rem",
  lineHeight: 1.8,
  color: "#333"
};